import { EntityOutputqueue } from "../../entity/EntityOutputqueue";

export class DtoOutputqueuesPutRes extends EntityOutputqueue {}
